import { Component, OnInit, Inject, Input, ViewChild, forwardRef } from '@angular/core';

import { BaseModuleComponent } from '~Interfaces/basemodulecomponent';
import { CongesService } from '../../services/conges.service';
import { ParametrageApplicatifService } from '../../services/parametrage-applicatif.service';

import { PopupComponent } from '~Components/popup/popup.component';
import { TableauComponent } from '~Components/tableau/tableau.component';
import { PageEvent } from '~Components/pagination/pagination.component';

import { DateConfig } from '~Tools/DateConfig';

import { IMyDateModel } from 'angular-mydatepicker';

/**
 * Composant du calendrier fiche relais
 * @extends BaseModuleComponent
 * @implements OnInit
 */
@Component({
    selector: 'app-fiche-relais-calendrier',
    templateUrl: './fiche-relais-calendrier.component.html',
    styleUrls: ['./fiche-relais-calendrier.component.scss'],
    providers: [{ provide: BaseModuleComponent, useExisting: forwardRef(() => FicheRelaisCalendrierComponent) }]
})
export class FicheRelaisCalendrierComponent extends BaseModuleComponent implements OnInit {
    listeCongesPageActuelle: any[];
    listeConges: any[];
    dateDebut: IMyDateModel = null;
    dateFin: IMyDateModel = null;
    commentaire: string = '';
    numeroPageActuelle: number = 1;
    nombreElementPage: number;

    datePickerOptions: any = DateConfig.datePickerOptions;
    datePickerOptionsDebut: any = { ...this.datePickerOptions };
    datePickerOptionsFin: any = { ...this.datePickerOptions };
    datePickerLocale: string = DateConfig.datePickerLocale;

    congesSaisieJours: any = this.parametrageApplicatifService.obtenir('param.conges.saisie.jours');
    congesSaisieActive: any = this.parametrageApplicatifService.obtenir('conges.saisie.actif');


    private filtres: boolean[] = [];

    @ViewChild('popupCalendrier', { static: false }) popupCalendrier: PopupComponent;
    @ViewChild('popupNePasAjouterConges', { static: false }) popupNePasAjouterConges: PopupComponent;
    @ViewChild('popupJeNePrendsPasDeConges', { static: false }) popupJeNePrendsPasDeConges: PopupComponent;
    @ViewChild('tableauCalendrier', { static: false }) tableauCalendrier: TableauComponent;

    @Input() codeFournisseur: string = '';
    @Input() codePays: string = '';
    @Input() codeLieu: string = '';
    isValidHollidays: boolean = false;

    /**
     * Constructeur
     */
    constructor(@Inject(CongesService) private congesService: CongesService, @Inject(ParametrageApplicatifService) private parametrageApplicatifService: ParametrageApplicatifService)
    {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Initialisation du composant module
     */
    Init() {
        // Initiliser les DatePicker
        this.initDatePicker();
        // lister les congés
        this.listerConges();

        this.getIsValidHollidays();
    }

    getIsValidHollidays() {
        this.congesService.getIsValidHollidays(this.codeLieu, this.codePays).subscribe(retour => {
            this.isValidHollidays = retour;
        })
    }

    /**
     * Initialiser les DatePicker
     */
    initDatePicker() {
        // Initialise les options des DatePicker
        // Bloquer les dates avant la date du jour
        let date = new Date();
        this.datePickerOptionsDebut.disableUntil = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDay()
        };
        this.datePickerOptionsFin.disableUntil = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDay()
        };
    }

    /**
     * Initialiser le DatePicker de fin
     */
    initDatePickerFin(dateDebut) {
        let datePickerOptionsFin = { ...this.datePickerOptionsFin };

        // Bloquer les dates avant la date de début
        datePickerOptionsFin.disableUntil = dateDebut;

        this.dateFin = null;
        this.datePickerOptionsFin = datePickerOptionsFin;
    }

    /**
     * Lister les congés
     */
    listerConges() {
        this.listeConges = [];
        this.congesService.listerConges(this.codeFournisseur).subscribe(retour => {
            if (retour && retour.Result && retour.Result.length) {
                for (let i = 0; i < retour.Result.length; i++) {
                    let c = retour.Result[i];

                    let dateDebut = new Date(c.DateDebut);
                    let dateFin = new Date(c.DateFin);
                    let dateAuj = new Date();

                    let cssClass = '';
                    if (dateAuj > dateFin) {
                        cssClass = 'line-disabled';
                    }
                    else if (dateDebut <= dateAuj && dateAuj <= dateFin) {
                        cssClass = 'line-active';
                    } 

                    this.listeConges.push({
                        Type: c.TypeConges.Libelle,
                        DateDebut: dateDebut,
                        DateFin: dateFin,
                        Commentaire: c.Commentaire,
                        IdCalendrierFermeture: c.IdCalendrierFermeture,
                        _cssClass: cssClass
                    });

                    // Changer le tri de la première colonne
                    setTimeout(() => {
                        if (this.tableauCalendrier) {
                            this.tableauCalendrier.changerEtatTri(0, true);
                        }
                    }, 100);
                }
            }
        }, err => {
            console.error(err);
        });
    }

    /**
     * Valider la non prise de congés durant les prochaines fêtes / étés
     */
    sendValidateHollidays() {
        this.congesService.validateHollidays(this.codeLieu, this.codePays).subscribe(retour => {
            if (retour == true) {
                this.isValidHollidays = true;
                this.popupJeNePrendsPasDeConges.fermer();
            }
        })

    }

    /**
     * Saisir les congés
     */
    saisirConges() {
        if (!(this.dateDebut && this.dateFin)) return;

        // Gestion des dates
        let dateDebut: Date = this.dateDebut.singleDate.jsDate;
        let dateFin: Date = this.dateFin.singleDate.jsDate;

        // Dates valides
        if (dateDebut && dateFin) {
            let commentaire: string = this.commentaire;
            let codeType: string = '';

            let codeFournisseur: string = this.codeFournisseur;

            // Saisie des congés
            this.congesService.saisirConges(codeFournisseur, dateDebut, dateFin, commentaire, codeType).subscribe(retour => {
                // Saisie OK
                if (retour && retour.Result === true) {
                    // Fermer la popup
                    if (this.popupCalendrier) {
                        this.popupCalendrier.fermer();
                    }
                    // Rafraichir la liste des congés
                    this.listerConges();
                }
                else {
                    //TODO: message d'erreur ?
                }
            }, err => {
                console.error(err);
            });
        }
    }

    supprimerConges(conges) {
        if (conges) {
            // Supprimer des congés
            this.congesService.supprimerConges(this.codeFournisseur, conges.DateDebut, conges.DateFin, '', conges.IdCalendrierFermeture).subscribe(retour => {
                // Supprimer OK
                if (retour && retour.Result === true) {
                    // Rafraichir la liste des congés
                    this.listerConges();
                }
                else {
                    //TODO: message d'erreur ?
                }
            }, err => {
                console.error(err);
            });
        }
    }

    /**
     * Ouvrir la saisie des congés
     */
    ouvrirPopupSaisie() {
        switch (window.location.hostname) {
            case 'my.mondialrelay.fr':
            case 'my-preview.mondialrelay.fr':
                this.codePays = 'FR';
                break;
            case 'my.mondialrelay.nl':
                this.codePays = 'NL';
                break;
            case 'mipunto.inpost.es':
                this.codePays = 'ES';
                break;
            case 'my.mondialrelay.be':
                this.codePays = 'BE'
                break;
            case 'meuponto.inpost.pt':
                this.codePays = 'PT'
                break;
            default:
                this.codePays = 'FR';
        }

        if (JSON.parse(this.congesSaisieActive)[this.codePays]) {
            this.popupCalendrier.ouvrir();
        } else {
            this.popupNePasAjouterConges.ouvrir();
        }
    }

    ouvrirPopupJeNePrendsPasDeConges() {
        this.popupJeNePrendsPasDeConges.ouvrir();
    }

    /**
     * Ouvrir la saisie des congés
     */
    ouvrirSaisieConges() {
        this.dateDebut = null;
        this.dateFin = null;
        this.commentaire = '';

        // Initiliser les DatePicker
        this.initDatePicker();

        return true;
    }

    /**
     * Fermer la saisie des congés
     */
    fermerSaisieConges() {
        return true;
    }

    /**
     * Afficher la confirmation
     */
    afficherConfirmation(): boolean {
        if (!(this.dateDebut && this.dateFin)) return false;
        if (this.congesSaisieJours == null) return false;

        let dateDebut: Date = this.dateDebut.singleDate.jsDate;
        let dateFin: Date = this.dateFin.singleDate.jsDate;

        if (dateDebut && dateFin)
        {
            let dateNow = new Date();
            dateNow.setHours(0);
            dateNow.setMinutes(0);
            dateNow.setSeconds(0);
            dateNow.setMilliseconds(0);

            let dateNowConges = new Date();
            dateNowConges.setDate(dateNowConges.getDate() + parseInt(this.congesSaisieJours, 10));

            if (dateNow <= dateDebut && dateDebut <= dateNowConges) {
                return true;
            }
        }

        return false;
    }

    /**
     * Réinitialiser la confirmation
     */
    resetConfirmation() {
        // Réinitialiser la conformation sur le composant de popup
        if (this.popupCalendrier) {
            this.popupCalendrier.resetConfirmation();
        }
    }

    /**
     * Changement de date de début
     */
    changementDateDebut(event) {
        this.resetConfirmation();
        this.initDatePickerFin(event.singleDate.date);
    }

    /**
     * Changement de date de fin
     */
    changementDateFin(event) {
        this.resetConfirmation();
    }

    /**
     * Evénement lors du changement de page
     * @param e
     */
    public changementPageEvent(e: PageEvent) {
        this.listeCongesPageActuelle = [];

        this.numeroPageActuelle = e.indexPage;
        this.nombreElementPage = e.taillePage;

        if (!this.filtres.length) {
            this.filtres['DateDebut'] = true;
            this.trier('DateDebut');
        }

        this.paginer();
    }

    /**
     * Trier la liste sur une colonne
     * @param index
     */
    trier(index: string) {
        // Récupère l'ordre de tri
        let ordreTri: boolean = !!this.filtres[index];

        // Réinitialise les filtres
        this.filtres = [];

        // Tri de la liste
        this.listeConges = this.listeConges.sort((a, b) => {
            if (a[index] > b[index]) {
                return ordreTri ? 1 : -1;
            }
            else {
                return ordreTri ? -1 : 1;
            }
        });

        this.paginer();

        // Indique le nouvel ordre de tri pour le prochain tri
        this.filtres[index] = !ordreTri;
    }

    /**
     * Paginer la liste
     */
    paginer() {
        this.listeCongesPageActuelle = [];

        let debut = this.numeroPageActuelle * this.nombreElementPage;
        let fin = debut + this.nombreElementPage;

        if (fin > this.listeConges.length) {
            fin = this.listeConges.length;
        }

        for (let i = debut; i < fin; i++) {
            this.listeCongesPageActuelle.push(this.listeConges[i]);
        }
    }

    /**
     * Convertir une date
     * @param dateString
     */
    private convertirDate(dateString: string): Date {
        if (!dateString) return null;

        var dateParts = dateString.split('/');
        if (!dateParts || dateParts.length != 3) return null;

        var dateObject = new Date(+dateParts[2], parseInt(dateParts[1], 10) - 1, +dateParts[0]);
        return dateObject;
    }
}
